import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import FixedButton from '../FixedButton';
import MobileNavigation from '../MobileNavigation';
import { fatchLRAPI,DeleteLrAPI,EditQuotationAPI} from '../../redux/actionCreation';
import DatePicker from 'react-datepicker';
import { parseISO, format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import LrEditPop from './LrEditPop'; // Naya component import karein


function LrList() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loading_update, setLoading_update] = useState(false);
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dispatch = useDispatch();
    let quotationtCounter = 0;
    const ref = useRef(null);
    const ref2 = useRef(null);
    const sidebarState = useSelector(state => state.sidebarReducres);
    const fetchLrReducers = useSelector(state => state.fetchLrReducers);
    const [selectedLrId, setselectedLrId] = useState(null);
    const [filteredLr, setFilteredLr] = useState([]);
    const error_edit = useSelector(state => state.EditQuotationReducers.error?.edit_quotation_errors) ?? null;
    
     // Update Quotation Function
      const [formData, setFormData] = useState({
        lr_date: today,
        lr_number: "",
        risk_type: "AT OWNER'S RISK",
        truck_number: "",
    
        driver_name: "",
        driver_phone: "",
        driver_licence: "",
    
        consignor_name: "",
        consignor_phone: "",
        consignor_gst: "",
        consignor_state: "",
        consignor_city: "",
        consignor_add: "",
    
        consignee_name: "",
        consignee_phone: "",
        consignee_gst: "",
        consignee_state: "",
        consignee_city: "",
        consignee_add: "",
    
        no_package: "",
        ac_weight: "",
        ac_weight_type: "KG",
        char_weight: "",
        charg_weight_type: "KG",
        pack_condition: "ALL ITEMS IN GOOD CONDITION",
        pack_desc: "",
        remark: "",
    
        f_to_bill: "",
        f_paid: "",
        f_to_pay: "",
        total_basic_f: "",
    
        loading_charge: "",
        unloading_charge: "",
        st_charge: "",
        other_charge: "",
        lrcn_charge: "",
    
        gst_per: "18",
        gst_paid_by: "Exempted",
    
        material_Insu: "Insured",
        insu_company: "",
        policy_num: "",
        insu_date: today,
        insu_amount: "",
        insu_risk: "",
    
        demurrage_charge: "500",
        demurrage_type: "Per Day",
        demurrage_time: "More Than 5 Day",
      });
      

    useEffect(() => {
        setFilteredLr(fetchLrReducers.data);
  }, [fetchLrReducers.data]); 
  
  
    const [lrNumber, setLrNumber] = useState("");
    const [consignorPhone, setConsignorPhone] = useState("");
    const [consigneePhone, setConsigneePhone] = useState("");

  // Datewise Filter Code Start
const handleFormSubmit = (event) => {
    event.preventDefault();

    const newFilteredLr = fetchLrReducers.data.filter((item) => {

        // Date Filter
        const itemDate = new Date(item.lr_date);

        const isWithinRange =
            (!formdate || itemDate >= formdate) &&
            (!todate || itemDate <= new Date(todate.getTime() + 86400000));

        // Exact LR Number Match
        const isLrMatch =
            !lrNumber ||
            item.lr_number?.toString() === lrNumber.toString();

        // Consignor Mobile Match
        const isConsignorMatch =
            !consignorPhone ||
            item.consignor_phone?.toString().includes(consignorPhone);

        // Consignee Mobile Match
        const isConsigneeMatch =
            !consigneePhone ||
            item.consignee_phone?.toString().includes(consigneePhone);

        return (
            isWithinRange &&
            isLrMatch &&
            isConsignorMatch &&
            isConsigneeMatch
        );
    });

    setFilteredLr(newFilteredLr);
};
// Datewise Filter Code End

const formatDate = (dateString) => {
    // Agar dateString khali hai, null hai ya "NA" hai, toh khali string return karo
    if (!dateString || dateString === "NA" || dateString === "" || dateString === "0000-00-00") {
        return ""; 
    }

    const date = new Date(dateString);

    // Check karo ki date valid hai ya nahi (RangeError se bachne ke liye)
    if (isNaN(date.getTime())) {
        return "";
    }

    try {
        const formattedDate = date.toISOString().split('T')[0];
        return formattedDate;
    } catch (error) {
        console.error("Format Date Error:", error);
        return "";
    }
};

 const UpdateLrClick = (LrId) => {
  setselectedLrId(LrId);

  const selectedLr = fetchLrReducers.data.find(lr => lr.id === LrId);

  const defaultTime = new Date();
  defaultTime.setHours(0, 0, 0, 0);

  if (selectedLr) {
    setFormData({
      ...formData,

      /* ================= LR DETAILS ================= */
      lr_date: selectedLr.lr_date ? new Date(selectedLr.lr_date + 'T00:00:00') : defaultTime,
      lr_number: selectedLr.lr_number,
      risk_type: selectedLr.risk_type,
      truck_number: selectedLr.truck_number,

      /* ================= DRIVER ================= */
      driver_name: selectedLr.driver_name,
      driver_phone: selectedLr.driver_phone,
      driver_licence: selectedLr.driver_licence,

      /* ================= CONSIGNOR ================= */
      consignor_name: selectedLr.consignor_name,
      consignor_phone: selectedLr.consignor_phone,
      consignor_gst: selectedLr.consignor_gst,
      consignor_state: selectedLr.consignor_state,
      consignor_city: selectedLr.consignor_city,
      consignor_add: selectedLr.consignor_add,

      /* ================= CONSIGNEE ================= */
      consignee_name: selectedLr.consignee_name,
      consignee_phone: selectedLr.consignee_phone,
      consignee_gst: selectedLr.consignee_gst,
      consignee_state: selectedLr.consignee_state,
      consignee_city: selectedLr.consignee_city,
      consignee_add: selectedLr.consignee_add,

      /* ================= PACKAGE ================= */
      no_package: selectedLr.no_package,
      ac_weight: selectedLr.ac_weight,
      ac_weight_type: selectedLr.ac_weight_type,
      char_weight: selectedLr.char_weight,
      charg_weight_type: selectedLr.charg_weight_type,
      pack_condition: selectedLr.pack_condition,
      pack_desc: selectedLr.pack_desc,
      remark: selectedLr.remark,

      /* ================= FREIGHT ================= */
      f_to_bill: selectedLr.f_to_bill,
      f_paid: selectedLr.f_paid,
      f_to_pay: selectedLr.f_to_pay,
      total_basic_f: selectedLr.total_basic_f,
      loading_charge: selectedLr.loading_charge,
      unloading_charge: selectedLr.unloading_charge,
      st_charge: selectedLr.st_charge,
      other_charge: selectedLr.other_charge,
      lrcn_charge: selectedLr.lrcn_charge,

      gst_per: selectedLr.gst_per,
      gst_paid_by: selectedLr.gst_paid_by,

      /* ================= INSURANCE ================= */
      material_Insu: selectedLr.material_Insu,
      insu_company: selectedLr.insu_company,
      policy_num: selectedLr.policy_num,
      insu_date: selectedLr.insu_date ? new Date(selectedLr.insu_date + 'T00:00:00') : defaultTime,
      insu_amount: selectedLr.insu_amount,
      insu_risk: selectedLr.insu_risk,

      /* ================= DEMURRAGE ================= */
      demurrage_charge: selectedLr.demurrage_charge,
      demurrage_type: selectedLr.demurrage_type,
      demurrage_time: selectedLr.demurrage_time,
    });
  } else {
    console.log("LR not found");
  }
};


// Delete Quotation Function
       const DeleteLr = async (LrId) => {
        // Show confirmation SweetAlert
        const result = await Swal.fire({
            title: `Are you sure Delete LR ?`,
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#673ab7',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                await dispatch(DeleteLrAPI(LrId));
                dispatch(fatchLRAPI());
            } catch (error) {
            //   console.error('Error:', error);
            }
        } else {
            // User clicked "Cancel" or closed the SweetAlert
            console.log('Deletion cancelled.');
        }
    };


    const [formdate, setFormDate] = useState(null);
    const [todate, setToDate] = useState(null);
    const fromDate = (date) => {
        setFormDate(date);
      };
      const toDate = (date) => {
        setToDate(date);
      };

        useEffect(() => {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const res = await dispatch(fatchLRAPI());
                    setLoading(false);
                    // Process the result if needed
                } catch (error) {
                    setLoading(false);
                    console.log('Error fetching data:', error);
                }
            };
            fetchData(); // Call the async function
        }, []);

   // State for From Location
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState([]);

  // State for To Location
  const [selectedToState, setSelectedToState] = useState(null);
  const [selectedToCity, setSelectedToCity] = useState(null);
  const [toCities, setToCities] = useState([]);

  // Get all Indian states
  const states = State.getStatesOfCountry("IN").map((state) => ({
    value: state.isoCode,
    label: state.name,
  }));

  // Load Cities when Editing
  useEffect(() => {
    if (formData.from_state) {
      const stateObject = states.find((state) => state.value === formData.from_state);
      setSelectedState(stateObject);

      const filteredCities = City.getCitiesOfState("IN", formData.from_state).map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setCities(filteredCities);

      if (formData.from_city) {
        const cityObject = filteredCities.find((city) => city.value === formData.from_city);
        setSelectedCity(cityObject);
      }
    }
  }, [formData.from_state, states]);

  useEffect(() => {
    if (formData.to_state) {
      const stateObject = states.find((state) => state.value === formData.to_state);
      setSelectedToState(stateObject);

      const filteredCities = City.getCitiesOfState("IN", formData.to_state).map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setToCities(filteredCities);

      if (formData.to_city) {
        const cityObject = filteredCities.find((city) => city.value === formData.to_city);
        setSelectedToCity(cityObject);
      }
    }
  }, [formData.to_state, states]);


  

  return (
    <>
        <FixedButton/>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h5 className='mb-1'>Search LR (Date, LR Number या Mobile Number से खोजें)</h5>
                        </Col>
                    </Row>

                    <Form onSubmit={handleFormSubmit}>
                        <Row className='search-list'>
                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <div className="date-picker-container">
                                    <i className='calendar-icon fa fa-calendar'></i>
                                    <DatePicker
                                        selected={formdate}
                                        onChange={fromDate}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="From Date"
                                        className='form-control'
                                    />
                                </div>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <div className="date-picker-container">
                                    <i className='calendar-icon fa fa-calendar'></i>
                                    <DatePicker
                                        selected={todate}
                                        onChange={toDate}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="To Date"
                                        className='form-control'
                                    />
                                </div>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="LR Number"
                                        value={lrNumber}
                                        onChange={(e) => setLrNumber(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="Consignor Mobile"
                                        value={consignorPhone}
                                        onChange={(e) => setConsignorPhone(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        placeholder="Consignee Mobile"
                                        value={consigneePhone}
                                        onChange={(e) => setConsigneePhone(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            {/* <Col xs="6" sm="6" md="2" lg="3" xl="3" xxl="3" className="mt-2">
                                <Form.Group className="" onChange={cut_num} controlId="formGroupEmail">
                                    <Form.Control type="number" min={0} placeholder="Customer Number" />
                                </Form.Group>
                            </Col> */}

                            {/* <Col xs="6" sm="6" md="2" lg="3" xl="3" xxl="3" className="mt-2">
                                <Form.Group className="" controlId="formGroupEmail">
                                    <Form.Control type="text" onChange={cut_name} placeholder="Customer Name" />
                                </Form.Group>
                            </Col> */}
                            
                            <Col xs="6" sm="6" md="2" lg="2" xl="2" xxl="2" className="mt-2">
                                <Button variant="primary" type="submit" className="">
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-4'>
                            <h5 className='mb-3'>LR List</h5>
                        </Col>
                    </Row>
                    <div className='text-center'>
                        {loading && <Loader />}
                    </div>

                    {!loading && (
                    <Row>
                        {filteredLr && Array.isArray(filteredLr) && filteredLr.length > 0 ? (
                        [...filteredLr].reverse().map(item => (
                        <Col key={item.id} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                            <div className="dash-count bill_box das3">
                                <div className="dash-counts">
                                    <h4 className="text-dark c_name">{item.consignor_name}</h4>
                                    <h5 className="text-dark text-green">LR #{item.lr_number}</h5>
                                    {item.lr_date && !isNaN(Date.parse(item.lr_date)) && (
                                        <h5 className="text-dark">
                                            {format(parseISO(item.lr_date), 'dd-MM-yyyy')}
                                        </h5>
                                    )}
                                </div>

                                <div className="dash-imgs">
                                    <i className="text-dark invoice_i fa fa-indian-rupee-sign mr-0"></i>
                                    <span className="amount text-dark">{item.f_to_bill}</span>
                                        <p>
                                            <Link to={`/lredit/${item.id}`}>
                                                <i className='view_invoice_i pr-3 fa fa-eye'></i>
                                            </Link>

                                            <Link onClick={() => UpdateLrClick(item.id)}  type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdropLr" aria-controls="staticBackdropLr">
                                                <i className='view_invoice_i pr-3 fa fa-edit'></i>
                                            </Link>

                                            <Link to="#" onClick={() => DeleteLr(item.id)}>
                                                <i className='delet_invoice_i pr-3 fa fa-trash'></i>
                                            </Link>
                                        </p>
                                </div>
                            </div>
                            </Col>
                        ))
                        ) : (
                        <div className='text-center not_data mt-3'>
                            <i className="fa-solid fa-triangle-exclamation"></i>
                            <p>No data available</p>
                        </div>
                        )}
                    </Row>
                    )}
                </Container>
            </div>
            <MobileNavigation/>

           {/* Popup Component - All Logic is inside this */}
            <LrEditPop LrId={selectedLrId} allData={fetchLrReducers.data} />
        </div>
    </>
  )
}

export default LrList
